import React from "react";

export const Freshfast=()=>{
     return (
         <>
          Freshfast
         </>
     )
}